import { createSelector } from '@ngrx/store';
import { selectFeatureFlagsState } from './feature-flags.reducer';

export const selectFeatureFlags = createSelector(
	selectFeatureFlagsState,
	(state) => state.flags
);

export const selectFeatureFlagsLoaded = createSelector(
	selectFeatureFlagsState,
	(state) => state.loaded
);

export const selectFeatureFlagsLoading = createSelector(
	selectFeatureFlagsState,
	(state) => state.loading
);

export const selectFeatureFlagsError = createSelector(
	selectFeatureFlagsState,
	(state) => state.error
);

/**
 * Selector factory for checking individual feature flags
 * Usage: selectFeatureFlag('myFeature')
 */
export const selectFeatureFlag = (flagName: string) =>
	createSelector(selectFeatureFlags, (flags) => flags[flagName] === true);
